import { gql } from '@grandvisionhq/graphql';

const cartDetails = gql`
  fragment LoyaltyPointsCartDetailsFragment on Cart {
    id
    loyaltyDetails {
      cardNumber
      points
      cardNumberType
    }
  }
`;

export { cartDetails };
//# sourceMappingURL=cart-details.js.map
